export class TrainCycleSortDialogModel {
   cycleUID: string;

   cycleName: string;

   trains: Array<TrainCycleSort>;
}

export class TrainCycleSort {
   trainCycleUID: string;

   cycleUID: string;

   trainUID: string;

   trainName: string;

   ordering: number;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/train-cycle-sort-dialog/train-cycle-sort-dialog.model.ts